import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  variant?: 'default' | 'tip' | 'warning' | 'info';
}

const variantStyles = {
  default: {
    bgcolor: 'background.paper',
    borderColor: 'divider',
  },
  tip: {
    bgcolor: 'success.50',
    borderColor: 'success.main',
    borderLeft: '4px solid',
  },
  warning: {
    bgcolor: 'warning.50',
    borderColor: 'warning.main',
    borderLeft: '4px solid',
  },
  info: {
    bgcolor: 'info.50',
    borderColor: 'info.main',
    borderLeft: '4px solid',
  },
};

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  children,
  icon,
  variant = 'default',
}) => {
  const styles = variantStyles[variant];

  return (
    <Paper
      elevation={variant === 'default' ? 1 : 0}
      sx={{
        p: 3,
        mb: 3,
        ...styles,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        {icon && (
          <Box sx={{ color: variant === 'default' ? 'primary.main' : `${variant}.main`, mt: 0.5 }}>
            {icon}
          </Box>
        )}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            {title}
          </Typography>
          <Box sx={{ '& p': { mb: 1 }, '& p:last-child': { mb: 0 } }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default InfoCard;
